export default __webpack_public_path__ + "static/media/settings.991c78db.svg";